import { render, staticRenderFns } from "./LowStockItemsTables.vue?vue&type=template&id=77bc3db5"
import script from "./LowStockItemsTables.vue?vue&type=script&lang=js"
export * from "./LowStockItemsTables.vue?vue&type=script&lang=js"
import style0 from "./LowStockItemsTables.vue?vue&type=style&index=0&id=77bc3db5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports